import About from "./pages/About";
import Balance from "./pages/Balance";
import Cart from "./pages/Cart";
import Contacts from "./pages/Contacts";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Orders from "./pages/Orders";
import PageNotFound from "./pages/PageNotFound";
import Privcacy from "./pages/Privcacy";
import Register from "./pages/Register";
import Settings from "./pages/Settings";
import Shop from "./pages/Shop";

export const routes = [
  {
    path: "/",
    Component: Home,
    exact: true,
  },
  {
    path: "/about",
    Component: About,
    exact: true,
  },
  {
    path: "/contacts",
    Component: Contacts,
    exact: true,
  },
  {
    path: "/shop",
    Component: Shop,
    exact: true,
    private: true,
  },
  {
    path: "/cart",
    Component: Cart,
    exact: true,
    private: true,
  },
  {
    path: "/orders",
    Component: Orders,
    exact: true,
    private: true,
  },
    {
    path: "/settings",
    Component: Settings,
    exact: true,
    private: true,
  },
  {
    path: "/balance",
    Component: Balance,
    exact: true,
    private: true,
  },
  {
    path: "/register",
    Component: Register,
    exact: true,
    guest: true
  },
  {
    path: "/privacy",
    Component: Privcacy,
    exact: true,
  },
  {
    path: "/login",
    Component: Login,
    exact: true,
    guest: true
  },
  {
    path: "/404",
    Component: PageNotFound,
    exact: true,
  },
];

export default routes;